import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

export const getPresignedUrl = async (intentId: string, data: any) => {
  const response = await axios.post(`/intents/${intentId}/file/upload`, data);
  return response.data;
};

export const uploadToS3 = async (presignedUrl: string, file: File) => {
  const response = await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': 'application/octet-stream',
    },
  });
  return response.status === 200 ? 'UPLOADED' : 'FAILED';
};

export const updateFileStatus = async (intentId: string, fileId: string, data: any) => {
  const response = await axios.patch(`/intents/${intentId}/file/${fileId}`, data);
  return response.status;
};

const uploadFile = async ({ intentId, file }: { intentId: string; file: File }) => {
  const { url: presignedUrl, id: fileId } = await getPresignedUrl(intentId, {
    filename: file.name,
    file_metadata: {},
  });
  const uploadStatus = await uploadToS3(presignedUrl, file);
  await updateFileStatus(intentId, fileId, {
    status: uploadStatus,
    extension: file.type.split('/')[1],
    size: file.size,
    file_metadata: {},
  });

  return { fileId };
};

export function useFileUpload() {
  const { mutate, isError, isPending, isSuccess } = useMutation({
    mutationFn: uploadFile,
  });

  return {
    uploadFile: mutate,
    isUploading: isPending,
    isError,
    isUploaded: isSuccess,
  };
}
